module.exports = __webpack_public_path__ + "img/dots.2dd47019.svg";